<template>
    <b-modal
        ref="modal"
        :title="id ? item.originalData.name : $t('New Foundation')"
        :visible="visible"
        scrollable
		    no-close-on-backdrop
        size="xl"
        style="min-height: 500px;"
        @change="$emit('update:visible', $event)"
        @hidden="onClose || onHidden()"
    >
        <template #modal-footer>
            <b-button v-if="item.id" variant="secondary" @click="handleDuplicate">
                {{ $t('Duplicate') }}
            </b-button>

            <b-button :disabled="item.busy" class="ml-auto" variant="primary" @click="handleSave">
                {{ item.id ? $t('Save') : $t('Create') }}
                <b-spinner v-show="item.busy" small />
            </b-button>
        </template>

        <b-form @keydown="item.onKeydown($event)" @submit.prevent="handleSave" @change="item.errors.clear()">
            <loading-bar v-if="pending" class="mx-n3" />
            <b-tabs v-else content-class="mt-3">
                <b-tab :title="$t('General')">
                    <b-form-group
                        :invalid-feedback="item.errors.get('name')"
                        :label="$t('Name')"
                        :state="item.errors.has('name') ? false : null"
                        label-for="name"
                    >
                        <b-form-input
                            id="name"
                            ref="name"
                            v-model="item.name"
                            :state="item.errors.has('name') ? false : null"
                            name="name"
                        />
                    </b-form-group>

                    <b-form-group
                        :invalid-feedback="item.errors.get('type')"
                        :label="$t('Type')"
                        :state="item.errors.has('type') ? false : null"
                        label-for="type"
                    >
                        <b-form-select
                            id="type"
                            ref="type"
                            v-model="item.type"
                            :disabled="!!(item.services && item.services.length)"
                            :options="types"
                            :state="item.errors.has('type') ? false : null"
                            name="type"
                        />
                    </b-form-group>

                    <b-form-group
                        :invalid-feedback="item.errors.get('foundation_id')"
                        :label="$t('Foundation')"
                        :state="item.errors.has('foundation_id') ? false : null"
                        label-for="foundation_id"
                    >
                        <foundation-select
                            id="foundation_id"
                            v-model="item.foundation"
                            :state="item.errors.has('foundation_id') ? false : null"
                            name="foundation_id"
                            resource="foundations"
                            @input="item.foundation_id = $event ? $event.id : null"
                        />
                    </b-form-group>

                    <input hidden type="submit">
                </b-tab>

                <b-tab :title="$t('Walls')">
                  <walls-tree-select
                      v-model="item.walls"
                      :errors="item.errors"
                      :project-id="projectId"
                      :disabled-function="foundationExists"
                      error-prefix="walls"
                      api-base="/api/floors/"
                  />
                </b-tab>


                <b-tab :title="$t('Services')">
                    <services-select
                        v-if="item.type"
                        v-model="item.services"
                        :api-url="item.id ? `/api/project-foundations/${item.id}/services` : null"
                        :multipliers="servicesMultipliers"
                        :params="{unit: 'm2'}"
                        :project-id="projectId"
                    />
                    <b-alert v-else show variant="warning">
                        {{ $t('Please select the type') }}
                    </b-alert>
                </b-tab>
            </b-tabs>
        </b-form>
    </b-modal>
</template>

<script>
    import Form from 'vform';
    import FoundationSelect from '@/components/selects/ResourceSelect';
    import FloorSelect from '@/components/selects/ResourceSelect';
    import ServicesSelect from '@/components/ServicesSelect';
    import WALLS_FIELDS_LOOKUP from "@/constants/walls_fields_lookup";
    import {WALL_TYPES} from "@/constants";

    import {sortBy} from 'lodash';
    import TreeView from "@/components/TreeView";
    import itemMixin from "@/mixins/itemMixin";
    import WallsTreeSelect from "@/components/selects/WallsTreeSelect";

    export default {
        name: "ProjectFoundationsCreateView",
        components: {WallsTreeSelect,ServicesSelect, FoundationSelect},
        mixins: [itemMixin],
        props: {
            projectId: { //id in URL, passed by router
                type: [Number, String],
                required: true,
            },
            visible: {
                type: Boolean,
                default: true
            },
            onClose: {
                type: Function,
                default: null
            }
        },
        computed: {
            resourceName() {
                return `projects/${this.projectId}/foundations`;
            },

            servicesMultipliers() {
                return (WALLS_FIELDS_LOOKUP[this.item.type] || []).filter(field => field.append === 'm');
            },

            types() {
                let types = Object.values(WALL_TYPES).map(type => {
                    return {
                        value: type,
                        text: this.$t(type),
                    }
                })


                return sortBy(types, 'text');
            }
        },

        beforeEnter: (to, from, next) => {
            if (this.$gate.allow('create', 'foundation')) {
                next();
            } else {
                this.forbiddenToast(this.$t('You are not allowed to create foundations'));
                next({name: 'projects.foundations', params: to.params})
            }
        },

        // beforeUpdate(to, from) {
        //     if (this.$gate.allow('create', 'foundation')) {
        //         this.$refs.modal.show();
        //     } else {
        //         this.forbiddenToast(this.$t('You are not allowed to create foundations'));
        //         next({name: 'projects.foundations', params: to.params})
        //     }
        // },

        methods: {
            handleDuplicate() {
                this.$set(this.item, 'id', null);
                this.$set(this.item, 'name', null);

                this.$refs.name.focus();
            },

            onHidden() {
                this.$router.push({name: 'projects.foundations', params: {projectId: this.projectId}})
            },

            disabledFunction(item) {
                return item.completed_foundation_services_count !== undefined && item.completed_foundation_services_count > 0;
            },
            foundationExists(item) {
              if (item.foundation) {
                if(item.foundation.name === this.item.name) {
                  return false;
                }
                return false;
              }
              return false;
            }
        }
    }
</script>

<style scoped>
 >>> #floor_id .multiselect__content-wrapper {
     position: relative;
 }
</style>
